import React, { useState, useEffect, useRef, useCallback } from "react";
import { IoSend } from "react-icons/io5";
import { useWebSocketContext } from "context/WebSocketContext";

const ChatWindow = ({ chatId, user, messages, onAddMessage, clientId, onResolve }) => {
  const [message, setMessage] = useState("");
  const chatEndRef = useRef(null);
  const { sendMessage, socketMessage } = useWebSocketContext();
  const processedMessagesRef = useRef(new Set());

  const handleIncomingMessage = useCallback(
    (data) => {
      console.log("Received socket message in admin:", data);

      if (
        data.event_type === "USER_MESSAGE" ||
        data.event_type === "AGENT_NEW_NOTIFICATION" ||
        data.event_type === "USER_REPLY"
      ) {
        if (chatId && data.escalation_chat_id && data.escalation_chat_id !== chatId) {
          return;
        }

        const messageKey = data.message_id || `${data.escalation_chat_id}-${data.message}`;
        if (!processedMessagesRef.current.has(messageKey)) {
          processedMessagesRef.current.add(messageKey);
          onAddMessage({
            id: data.message_id,
            text: data.message,
            sender: "User",
            timestamp: data.timestamp,
          });
        }
      }
    },
    [chatId, onAddMessage]
  );

  useEffect(() => {
    if (socketMessage) {
      handleIncomingMessage(socketMessage);
    }
  }, [socketMessage, handleIncomingMessage]);

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);
  const handleSendMessage = () => {
    const trimmedMessage = message.trim();
    if (trimmedMessage && chatId && clientId) {
      const messageId =
        window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`;
      onAddMessage({ id: messageId, text: trimmedMessage, sender: "You" });
      setMessage("");
      const data = {
        client_id: clientId,
        message: trimmedMessage,
        escalation_chat_id: chatId,
        message_id: messageId,
      };
      sendMessage(data);
    }
  };

  return (
    <div className="flex w-full flex-col">
      {user ? (
        <div className="flex h-full flex-col">
          <div className="flex items-center justify-between border-b p-4">
            <div>
              <div className="text-xl font-semibold">{user.name}</div>
              <div className="text-sm text-gray-500">{user.roomNo}</div>
            </div>
            <button
              onClick={onResolve}
              className="rounded-lg bg-green-600 px-4 py-2 text-sm text-white"
            >
              Resolve
            </button>
          </div>
          <div className="flex-1 overflow-y-auto p-4">
            {messages.map((msg, index) => (
              <div
                key={index}
                className={`mb-2 ${msg.sender === "You" ? "text-right" : "text-left"}`}
              >
                <div
                  className={`inline-block rounded-lg px-4 py-2 ${
                    msg.sender === "You" ? "bg-blue-500 text-sm text-white" : "bg-gray-100 text-sm"
                  }`}
                >
                  {msg.text}
                </div>
              </div>
            ))}
            <div ref={chatEndRef} />
          </div>
          <div className="chatInputBox mt-auto flex">
            <input
              type="text"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSendMessage()}
              className="w-full rounded-lg border p-2"
              placeholder="Type a message..."
              disabled={!chatId || !clientId}
            />
            <button
              onClick={handleSendMessage}
              className="sendBtn ml-2 rounded-lg bg-blue-500 px-4 py-2 text-white"
              disabled={!chatId || !clientId}
            >
              <IoSend />
            </button>
          </div>
        </div>
      ) : (
        <div className="flex h-full items-center justify-center">
          <p className="text-gray-500">Select a user to start chatting</p>
        </div>
      )}
    </div>
  );
};

export default ChatWindow;
